<template>
  <div class="container g-flex g-row-center">
    <div class="total-width g-p-b-16" v-loading="loading">
      <!--  课程一级分类  -->
      <div class="g-flex g-col-top">
        <p class="g-font-16 main-text g-font-weight-6 g-m-t-15 g-m-r-15 g-nowrap">一级分类</p>
        <div class="g-flex g-rela" style="flex-flow:wrap !important;">
          <div class="tag-item g-nowrap pointer"
               :class="{'active':radioSelectIndex === index}"
               @click="radioSelectClassify(item,index)" v-for="(item,index) in courseClassifyTree" :key="index">
            {{ item.name }}
          </div>
        </div>
      </div>
      <!--  课程二级分类  -->
      <div class="g-flex g-col-top">
        <p class="g-font-16 main-text g-font-weight-6 g-m-t-15   g-m-r-15 g-nowrap">二级分类</p>
        <div class="g-flex g-rela" style="flex-flow:wrap !important;">
          <div class="tag-item g-nowrap pointer"
               :class="{'active':item.active}"
               @click="selectClassify(item)" v-for="(item,index) in courseClassifySub" :key="index">
            {{ item.name }}
          </div>
        </div>
      </div>

      <!--   其他单选   -->
      <div class="g-flex g-col-top">
        <p class="g-font-16 main-text g-font-weight-6 g-m-t-15 g-m-r-15 g-nowrap">课程等级</p>
        <div class="g-flex g-rela" style="flex-flow:wrap !important;">

          <div class="tag-item g-nowrap pointer" @click="selectGrade(null,'all')"
               :class="{'active':radioIndex ==='all'}">
            不限
          </div>
          <div class="tag-item g-nowrap pointer"
               :class="{'active':radioIndex === index}"
               @click="selectGrade(item,index)" v-for="(item,index) in courseGrade" :key="index">
            {{ item.name }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import cityPopup from "@/views/find-job/components/city-popup";
import jobPositionPopup from "@/views/find-job/components/job-position-popup";
import {getClassifyGrade} from "@/api/education/course";

export default {
  components: {
    cityPopup,
    jobPositionPopup
  },
  props: {
    courseClassifyOne: ['String'],
    courseClassifyTwo: ['String'],
  },
  name: "course-filter",
  data() {
    return {
      courseClassifyTree: [
        {
          children: [],
          name: "不限",
          active: true
        }
      ],
      courseClassifySub: [],
      courseGrade: [],
      radioIndex: 'all',
      radioSelectIndex: 0,
      loading: false,
      subunlimited: true,
    }
  },
  created() {
    //查询分类和等级
    this.loading = true
    getClassifyGrade().then(res => {
      this.loading = false
      this.courseClassifyTree.push(...res.courseClassifyTree.map(e => {
        this.$set(e, 'active', false)
        return e
      }))
      if (this.courseClassifyTree.length > 0) {
        //回显选中
        if (this.courseClassifyOne) {
          let i = 0
          for (const item of this.courseClassifyTree) {
            if (item.id === this.courseClassifyOne) {
              this.radioSelectIndex = i
              if (this.courseClassifyTwo && item.children) {
                let active = true;
                const sub = item.children.map(v => {
                  if (this.courseClassifyTwo === v.id) {
                    active = false
                    this.$set(v, 'active', true)
                  } else {
                    this.$set(v, 'active', false)
                  }
                  return v
                })
                this.courseClassifySub.push(
                    {
                      children: [],
                      name: "不限",
                      active,
                    })
                this.courseClassifySub.push(...sub)
              } else {
                const sub = item.children.map(v => {
                  this.$set(v, 'active', false)
                  return v
                })
                this.courseClassifySub.push(
                    {
                      children: [],
                      name: "不限",
                      active: true,
                    })
                this.courseClassifySub.push(...sub)
              }

              break
            }
            i++
          }
        } else {
          this.radioSelectIndex = 0
          this.courseClassifySubAll()
        }
      }
      this.courseGrade = res.courseGrade
    }, error => {
      this.loading = false
    })
  },
  watch: {},
  methods: {
    //分类一级单选
    radioSelectClassify(val, index) {

      if (this.radioSelectIndex === index) {
        return
      }
      if (val.name === '不限') {
        this.radioSelectIndex = index
        this.courseClassifySubAll()
        this.$emit("classifyLevelOne", null, null)
        return;
      }
      this.courseClassifySub = [{
        children: [],
        name: "不限",
        active: true
      }]
      this.radioSelectIndex = index

      if (val.children) {
        const sub = val.children.map(v => {
          this.$set(v, 'active', false)
          return v
        })
        this.courseClassifySub.push(...sub)
      }
      this.$emit("classifyLevelOne", val.id)
    },
    //分类二级多选
    selectClassify(val) {
      for (const item of this.courseClassifySub) {
        item.active = false
      }
      val.active = true
      if (val.name === '不限') {
        this.subunlimited = true
        this.courseClassifySubAll()
        this.$emit("classifyLevelTwo", null,this.courseClassifyOne)
        return
      }
      //选中父类
      let i = 0
      for (let item of this.courseClassifyTree) {
        if (item.id === val.parentId) {
          this.radioSelectIndex = i
          if (this.subunlimited) {
            this.subunlimited = false
            //重新生成 二级分类
            this.courseClassifySub = [
              {
                children: [],
                name: "不限",
                active: false,
              }]
            const sub = item.children.map(v => {
              this.$set(v, 'parentId', item.id)
              this.$set(v, 'active', val.id === v.id)
              return v
            })
            this.courseClassifySub.push(...sub)
          }
          const id = this.courseClassifySub.filter(e => e.active).map(e => e.id).join(',')
          this.$emit("classifyLevelTwo", id, item.id)
          break
        }
        i++
      }
    },//获取所有二级分类
    courseClassifySubAll() {
      this.courseClassifySub = [{
        children: [],
        name: "不限",
        active: true
      }]
      for (const item of this.courseClassifyTree) {
        if(item.children){
          for (const v of item.children) {
            this.$set(v, 'parentId', item.id)
            this.$set(v, 'active', false)
            this.courseClassifySub.push(v)
          }
        }
      }
    },
    // 课程等级单选
    selectGrade(val, index) {
      this.radioIndex = index
      if (val === null) {
        this.$emit("gradeData", val)
      } else {
        this.$emit("gradeData", val.id)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #fff;
}

.main-text {
  height: 30px;
  line-height: 30px;
}

.tag-list {
  width: 82%;
  overflow-x: scroll;
}

.tag-item {
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  color: #666;
  margin-top: 15px;
}

.more-btn {
  background: #fff;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  margin-top: 15px;
}

.active {
  color: #fff;
  padding: 0 0.625rem;
  background-color: #407aff;
  border-radius: 0.3125rem;
}

.multiple-tag {
  background: #f7f7f7;
  color: #666;
  margin: 15px 10px 0 10px;
}

.del-icon {
  width: 16px;
  height: 16px;
  position: absolute;
  right: -8px;
  top: -8px;
}
</style>
